import React from "react";
import "./Secondhero.scss";

import kiriatas from "../../Media/Foto_About/Kiri_Atas.png";
import kiribawah from "../../Media/Foto_About/Kiri_Bawah.png";
import kananatas from "../../Media/Foto_About/Kanan_Atas.png";
import kananbawah from "../../Media/Foto_About/Kanan_Bawah.png";

const SecondHero = () => {
  return (
    <div className="secondherocontainers" id="about">
      <div className="secondmiddle">
        <div className="leftcontent">
          <div className="content-judulabout">
            <h1>Kota Wisata </h1>
            <h2>Embracing Nature Better Future</h2>
          </div>
          <div className="contentdescription">
            Kota Wisata Cibubur adalah kawasan hunian terpadu berskala kota
            mandiri yang dikembangkan oleh Sinar Mas Land, berlokasi strategis
            di Cibubur. Mengusung konsep “Harmony of Nature and Modern Living”,
            kawasan ini memadukan suasana asri, lingkungan hijau, dan desain
            arsitektur modern untuk menghadirkan kualitas hidup terbaik bagi
            keluarga. Terbentang di atas lahan lebih dari 700 hektar, Kota
            Wisata Cibubur menghadirkan beragam pilihan hunian mulai dari
            cluster eksklusif modern, townhouse bergaya Eropa & tropis, hingga
            area komersial dan bisnis yang berkembang pesat. Setiap unit
            dirancang dengan tata ruang efisien, serta dilengkapi teknologi
            infrastruktur modern .
          </div>
        </div>
        <div className="rightcontent">
          <div className="leftpicture">
            <div className="kiriatas">
              <img src={kiriatas} className="satu" alt="Nava" />
            </div>
            <div className="kiribawah">
              <img src={kiribawah} className="dua" alt="Nava" />
            </div>
          </div>
          <div className="rightpicture">
            <div className="kananatas">
              <img src={kananatas} className="tiga" alt="Nava" />
            </div>
            <div className="kananbawah">
              <img src={kananbawah} className="empat" alt="Nava" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecondHero;
